import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get all notifications
 * */
export function* getBackendNotifications() {
    const response = yield call(api.getBackendNotifications);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_BACKEND_NOTIFICATIONS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_BACKEND_NOTIFICATIONS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetBackendNotifications() {
    while (true) {
        yield take(actionTypes.GET_BACKEND_NOTIFICATIONS.REQUEST);
        yield fork(getBackendNotifications);
    }
}

/**
 * Get one notification by id
 * */
export function* getBackendNotification(_id) {
    const response = yield call(api.getBackendNotification, _id);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_BACKEND_NOTIFICATION.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_BACKEND_NOTIFICATION.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetBackendNotification() {
    while (true) {
        const { _id } = yield take(actionTypes.GET_BACKEND_NOTIFICATION.REQUEST);
        yield fork(getBackendNotifications, _id);
    }
}

/**
 * Update notification by id
 * */
export function* updateBackendNotification(data) {
    const response = yield call(api.updateBackendNotification, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_BACKEND_NOTIFICATION.SUCCESS,
            data: data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Notification was updated',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 20,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 20,
        },
    });

    yield put({
        type: actionTypes.UPDATE_BACKEND_NOTIFICATION.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchUpdateBackendNotification() {
    while (true) {
        const { data } = yield take(actionTypes.UPDATE_BACKEND_NOTIFICATION.REQUEST);
        yield fork(updateBackendNotification, data);
    }
}

/**
 * Delete notification by id
 * */
export function* deleteBackendNotification(id) {
    const response = yield call(api.deleteBackendNotification, id);

    if (response.status === 200) {
        yield put({
            type: actionTypes.DELETE_BACKEND_NOTIFICATION.SUCCESS,
            data: id,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Notification was deleted',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 20,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 20,
        },
    });

    yield put({
        type: actionTypes.DELETE_BACKEND_NOTIFICATION.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchDeleteBackendNotification() {
    while (true) {
        const { id } = yield take(actionTypes.DELETE_BACKEND_NOTIFICATION.REQUEST);
        yield fork(deleteBackendNotification, id);
    }
}


/**
 * Create notification
 * */
export function* createBackendNotification(data) {
    const response = yield call(api.createBackendNotification, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.CREATE_BACKEND_NOTIFICATION.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Notification was created',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 20,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 20,
        },
    });

    yield put({
        type: actionTypes.CREATE_BACKEND_NOTIFICATION.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchCreateBackendNotification() {
    while (true) {
        const { data } = yield take(actionTypes.CREATE_BACKEND_NOTIFICATION.REQUEST);
        yield fork(createBackendNotification, data);
    }
}

export default [
    watchGetBackendNotifications,
    watchGetBackendNotification,
    watchDeleteBackendNotification,
    watchUpdateBackendNotification,
    watchCreateBackendNotification,
];



// WEBPACK FOOTER //
// ./app/sagas/notifications/backendNotifications.js